module.exports = __webpack_public_path__ + "static/media/bizdocs_devices.947334a1.png";